export const AUTH_SESSION_CLEARED_EVENT = 'pipeex:auth-session-cleared';

export function clearAuthSessionStorage(): void {
  console.warn('[AuthSession] Clearing session storage', new Error().stack?.split('\n').slice(1, 4).join(' <- '));
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(AUTH_SESSION_CLEARED_EVENT));
  }
}

